import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
    Container,
    Image,
    ContainerVersion,
    SubContainerButton,
    HeaderTitle,
    Title,
    ContainerTitle,
    ContainerImage,
    ContainerSelect,
    ContainerContent,
    ContainerIcons,
    Label,
    LinkTitle,
    ContainerLink,
} from './style';
import { MultiSelect } from '../../components/MultiSelect/MultiSelect';
import InputPassword from '../../components/InputPassword/InputPassword';
import Button from '../../components/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCogs } from '@fortawesome/free-solid-svg-icons';
import logo from '../../assets/images/logo.png';
import ModalAlert from '../../components/ModalAlert/ModalAlert';
import { checkGeolocation } from '../../helpers/geo';
import { homeReset, homeSave } from '../../services/store/reducers/home';
import { appConfigSave } from '../../services/store/reducers/appConfig';
import {
    fetchValidateUserStart,
    validateUserReset,
} from '../../services/store/reducers/endpoints/userValidation';
import { fetchCompaniesStart } from '../../services/store/reducers/endpoints/companies';
import { fetchLoginToConfigurationStart } from '../../services/store/reducers/endpoints/loginToConfiguration';
import { configurationReset } from '../../services/store/reducers/configuration';
import CurrentTime from '../../components/CurrentTime/CurrentTime';
import axios from 'axios';
import config from '../../config/configuration';

class Home extends PureComponent {
    state = {
        habilitado: false,
        company: '',
        senha: '',
        tentativasErradas: 0,
        senhaReadOnly: true,
        sended: false,
        sagaValidateUser: null, 
    };

    async UNSAFE_componentWillMount() { 
        this.props.homeReset();
        this.props.configurationReset();
        this.props.fetchCompaniesStart();
        let configuracaoGet = await axios.get(config.url + `configuracao/get`);
        //console.log('ue man -->', configuracaoGet.data.geoLocalizacao);
        console.log('ue man2 --> ', configuracaoGet.data);

        this.props.appConfigSave({ 
            geoLocalizacao: false, //configuracaoGet.data.geoLocalizacao,
            tamanhoMaximoSenha: configuracaoGet.data.tamanhoMaximoSenha,
            tamanhoMinimoSenha: configuracaoGet.data.tamanhoMinimoSenha
        });
    }

    handleCompanyOption(event) {
        let value = event.value;
        this.setState({ company: value, senha: '' });
        if (!this.state.habilitado) {
            //internet
            if (!window.navigator.onLine) {
                window.location.href = '/report-user?message=-&errorCode=1';
                return;
            }
            //location
            checkGeolocation().then((result) => {
                if (result) {
                    this.props.homeSave({ companyName: event.label, company: value, senha: '' });
                    //window.location.href = '/point-flow'
                    window.location.href = '/register-point';
                } else {
                    window.location.href = '/report-user?message=Você não esta com gps&errorCode=2';
                }
            });
        }
    }

    handleClick = () => {
        if (this.state.habilitado) {
            this.setState({ habilitado: false });
        } else {
            this.setState({ habilitado: true });
        }
    };

    clickAcessar = () => {
        if (!window.navigator.onLine) {
            window.location.href = '/report-user?message=-&errorCode=1';
            return;
        }
        this.props.validateUserReset();
        if (this.isSenhaValida()) {
            this.setState({
                sended: true,
            });
            this.props.fetchValidateUserStart({ password: this.state.senha });
        }
    };

    isSenhaValida = () => {
        if (this.state.senha.length < this.props.appConfig.tamanhoMinimoSenha) {
            this.setState({
                titleModal: 'Atenção!',
                messageModal: `A senha deve conter no mínimo ${this.props.appConfig.tamanhoMinimoSenha} caracteres.`,
            });
            return false;
        }
        if (this.state.senha.length > this.props.appConfig.tamanhoMaximoSenha) {
            this.setState({ 
                titleModal: 'Atenção!',
                messageModal: `A senha deve conter no máximo ${this.props.appConfig.tamanhoMaximoSenha} caracteres.`,
            });
            return false;
        }

        return true;
    };

    toConfiguration = () => {
        const { sagaValidateUser } = this.props;

        this.setState({
            sended: false,
        });

        if (Array.isArray(sagaValidateUser) && sagaValidateUser.length === 0) {
            this.setState({
                tentativasErradas: this.state.tentativasErradas + 1,
                titleModal: 'Atenção!',
                messageModal: 'Senha inválida',
            });
        } else {
            checkGeolocation().then((result) => {
                if (result) {
                    this.props.homeSave({ company: this.state.company, senha: '' });
                    window.location.href = '/configuration';
                } else {
                    window.location.href = '/report-user?message=Você não esta com gps&errorCode=2';
                }
            });
        }
    };
    handleKeyPress = (event) => {
        console.log('===', event.key);

        if (event.key === 'Enter') {
            this.clickAcessar();
        }
    };

    render() {
        const { sagaCompanies, sagaValidateUser } = this.props;

        return (
            <Container>
                <ContainerImage>
                    <Image src={logo} />
                </ContainerImage>
                <CurrentTime></CurrentTime>
                <ContainerTitle>
                    <HeaderTitle>Controle de Ponto</HeaderTitle>
                </ContainerTitle>

                {!this.state.habilitado && (
                    <ContainerSelect>
                        <Title>Empresa</Title>
                        <MultiSelect
                            options={
                                !sagaCompanies
                                    ? []
                                    : sagaCompanies.map((val) => {
                                          return {
                                              value: val.codigoEmpresaSAR,
                                              label: val.nome,
                                          };
                                      })
                            }
                            onChange={(event) => {
                                this.handleCompanyOption(event);
                            }}
                            placeholder={'Selecione'}
                        />
                    </ContainerSelect>
                )}

                {this.state.habilitado && (
                    <ContainerContent>
                        <Label>Senha</Label>
                        <InputPassword
                            type='text'
                            padding={'5px'}
                            autoComplete={'off'}
                            readOnly={this.state.senhaReadOnly}
                            onFocus={this.setState({ senhaReadOnly: false })}
                            onChange={(event) => {
                                this.setState({ senha: event.target.value });
                            }}
                            onKeyPress={(event) => {
                                this.handleKeyPress(event);
                            }}
                            name='oldPassword'
                        />
                        <SubContainerButton>
                            {this.state.tentativasErradas >= 2 && (
                                <Button
                                    backgroundColor='#40bbca'
                                    onClick={() => {
                                        this.handleClick();
                                        this.setState({ tentativasErradas: 0 });
                                    }}
                                >
                                    Voltar
                                </Button>
                            )}
                            <Button
                                backgroundColor='#40bbca'
                                onClick={() => {
                                    this.clickAcessar();
                                }}
                            >
                                Acessar
                            </Button>
                        </SubContainerButton>
                    </ContainerContent>
                )}

                <div style={{ position: 'absolute', bottom: '70px' }}>
                    <ContainerLink>
                        <LinkTitle>
                            <a
                                style={{ padding: '5px' }}
                                href={'https://institucional.nicbrain.com.br/termos-de-uso'}
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <font style={{ color: 'white' }}>Termos de Uso</font>
                            </a>
                        </LinkTitle>
                    </ContainerLink>
                    <ContainerLink>
                        <LinkTitle>
                            <a
                                style={{ padding: '5px' }}
                                href={
                                    'https://institucional.nicbrain.com.br/politica-de-privacidade/'
                                }
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <font style={{ color: 'white' }}>Políticas de Privacidade</font>
                            </a>
                        </LinkTitle>
                    </ContainerLink>
                </div>

                <ContainerVersion>Versão 1.0.5</ContainerVersion>
                <ContainerIcons>
                    <FontAwesomeIcon onClick={this.handleClick} icon={faCogs} />
                </ContainerIcons>
                {this.state.sended && sagaValidateUser && this.toConfiguration()}
                {
                    //para colocar os pop up
                    this.state.titleModal &&
                        this.state.messageModal &&
                        this.state.titleModal.length > 0 &&
                        this.state.messageModal.length > 0 && (
                            <ModalAlert
                                title={this.state.titleModal}
                                message={this.state.messageModal}
                                onClick={() => {
                                    this.setState({ messageModal: '', titleModal: '' });
                                }}
                            />
                        )
                }
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    home: state.home,
    appConfig: state.appConfig,
    sagaCompanies: state.sagaCompanies.data,
    sagaClients: state.sagaClients.data,
    sagaValidateUser: state.sagaValidateUser.data,
});

const mapDispatchToProps = (dispatch) => ({
    homeReset: () => dispatch(homeReset()),
    configurationReset: () => dispatch(configurationReset()),
    homeSave: (value) => dispatch(homeSave(value)),
    fetchCompaniesStart: (mss) => dispatch(fetchCompaniesStart(mss)),
    fetchLoginToConfigurationStart: (mss) => dispatch(fetchLoginToConfigurationStart(mss)),
    fetchValidateUserStart: (mss) => dispatch(fetchValidateUserStart(mss)),
    validateUserReset: () => dispatch(validateUserReset()),
    appConfigSave: (data) => dispatch(appConfigSave(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
